import React from 'react';
import { Typography } from '@mui/material';

export const OnboardingWelcome: React.FC = () => {
  return <Typography variant="h4">welcome!</Typography>;
};

export default OnboardingWelcome;
